export default {
	label: 'Rule | Rules',
	addRule: 'Add rule',
}
